<!-- /src/components/common/Sidebar/Menu.vue -->
<template>
  <ul class="menu sidebar-menu">
    <li class="sidebar-menu__item">
      <router-link
        class="sidebar-menu__itemLink"
        :to="{ name: 'sessions', params: { sessionType: 'sessions' } }"
        >Training Sessions</router-link
      >
    </li>
    <li class="sidebar-menu__item">
      <router-link
        class="sidebar-menu__itemLink"
        :to="{ name: 'courses', params: { sessionType: 'courses' } }"
        >Courses</router-link
      >
    </li>
    <li class="sidebar-menu__item">
      <router-link
        class="sidebar-menu__itemLink"
        :to="{
          name: 'relationships',
          params: { sessionType: 'relationships' },
        }"
        >Corporate Relationships</router-link
      >
    </li>
    <li class="sidebar-menu__item">
      <router-link class="sidebar-menu__itemLink" to="/bible-studies"
        >Bible Studies</router-link
      >
    </li>
    <li class="sidebar-menu__item">
      <router-link class="sidebar-menu__itemLink" to="/resources"
        >Resources</router-link
      >
    </li>
    <li class="sidebar-menu__item">
      <router-link class="sidebar-menu__itemLink" to="/bookmarks"
        >Bookmarks</router-link
      >
    </li>
    <li class="sidebar-menu__item">
      <router-link class="sidebar-menu__itemLink" to="/directory"
        >Corporate Directory</router-link
      >
    </li>
    <li v-if="1 == 2" class="sidebar-menu__item">
      <router-link class="sidebar-menu__itemLink" to="/training-manual"
        >Training Manual</router-link
      >
    </li>
  </ul>
</template>

<script>
export default {}
</script>

<style scoped>
.sidebar-menu {
  &__item {
    font-size: 1.4rem;
    text-transform: uppercase;
    padding: 0.25rem 0 0.75rem 0;
    line-height: 1;

    &Link {
      display: block;
      position: relative;
      transition: color 0.5s ease;
      will-change: color;

      &:after {
        content: '';
        position: absolute;
        bottom: -10px;
        left: 0;
        height: 4px;
        width: 0;
        background-color: var(--brandAccent);
        transition: width 0.5s ease;
        will-change: width;
      }

      &:hover {
        color: var(--brandAccent);
      }

      &:hover:after {
        width: 100%;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
